import type { WritableComputedOptions } from "vue"
import { object_map } from "@pdfking/rfunc"
import { IsString } from "@pdfking/tfunc"

type ProxyResult<K extends string> = {
  [P in K]: WritableComputedOptions<any, any>
}

export default <K extends string>(
  object: Record<string, any>,
  keys: K[] | Record<K, string>
): ProxyResult<K> =>
  object_map(
    (n: string) => n,
    (n: string, k: string | number) => {
      const target = IsString(k) ? (k as string) : n
      return {
        get: () => object[target],
        set: (v: any) => (object[target] = v),
      }
    },
    // @ts-expect-error - union type K[] | Record<K, string> not matched by overloads
    keys
  ) as ProxyResult<K>
